<template>
	<div>
		<div class="integral_info">
			<div class="title">My reward points</div>
			<div class="info flex align-center">
				<img src="../../../assets/images/icon/integral2.png" alt="">
				<div>{{userInfo.score}}</div>
			</div>
		</div>
		<div class="intetral_table">
			<el-table
			    :data="tableData"
			    style="width: 100%">
			  
			    <el-table-column
			      prop="createtime"
			      label="Date">
			    </el-table-column>
				<el-table-column
				  prop="score"
				  label="Points">
				</el-table-column>
				<el-table-column
				  prop="memo"
				  label="Details">
				</el-table-column>
			  </el-table>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				userInfo:{},
				 tableData: [{
				          date: '2022.2.22-2022.2.28',
						  time:'13:00-15:00',
				          name: '王小虎',
				          province: '上海',
				          city: '普陀区',
				          zip: 200333
				        },{
				          date: '2022.2.22-2022.2.28',
						  time:'13:00-15:00',
				          name: '王小虎',
				          province: '上海',
				          city: '普陀区',
				          zip: 200333
				        }]
			}
		},
		created(){
			this.getIntegralList();
			this.getUser()
		},
		methods:{
			getIntegralList(){
				this.$api.post('user/getIntegralList',{},res=>{
					if(res.code == 1){
						this.tableData = res.data.data
					}
				})
			},
			getUser(){
				this.$api.post('user/getUserDetails',{},res=>{
					if(res.code == 1){
						this.userInfo = res.data;
					}
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.integral_info{
		width: 1240px;
		height: 244px;
		background: #F7F2EB;
		box-shadow: 0px 8px 16px 0px rgba(92,112,122,0.6000);
		border-radius: 10px;
		margin-top: 20px;
		margin-left: 20px;
		padding: 40px 0 0 30px;
		.title{
			font-size: 20px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #282E30;
			margin-bottom: 30px;
		}
		.info{
			font-size: 30px;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #282E30;
			img{
				width: 115px;
				height: 113px;
				margin-right: 35px;
			}
		}
	}
	.intetral_table{
		width: 1240px;
		background: #F7F2EB;
		box-shadow: 0px 8px 16px 0px rgba(92,112,122,0.3000);
		border-radius: 10px;
		padding-bottom: 200px;
		margin-left: 20px;
		margin-top: 20px;
		::v-deep .el-table__header tr{
			background-color: #5C707A;
		}
		::v-deep .el-table th.el-table__cell{
			background-color: #5C707A;
		}
		::v-deep .el-table tr{
			background-color: #F7F2EB;
			padding-left: 70px;
		}
		::v-deep .el-table td:first-child{
			padding-left: 70px;
		}
		::v-deep .el-table th:first-child{
			padding-left: 70px;
		}
		::v-deep .el-table__row{
			font-size: 18px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #282E30;
			
		}
		::v-deep .el-table__row td{
			border-bottom: 1px solid #5C707A;
		}
		::v-deep .el-table__row .detail{
			color: #5C707A;
		}
		::v-deep .el-table thead{
			font-size: 20px;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #F7F2EB;
		}
		::v-deep .el-table tbody .el-table__row:hover>td {
		    background-color: transparent !important;
		}
	}
</style>